import { api } from "./axios";

// User related endpoints
export const userApi = {
  getProfile: () => api.get("/users/me"),
  updateProfile: (data: any) => api.put("/users/update-profile", data),
  updatePassword: (data: any) => api.put("/users/update-password", data),
  deleteAccount: (userId: number) => api.delete(`/users/${userId}`),
  uploadProfilePicture: (data: FormData) =>
    api.post("/users/profile-picture", data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }),

  exportData: () => api.get("/users/export-data"),
  getSubscriptionDetails: () =>
    api.get("/subscription/get-subscription-details"),
  createPortalSession: () => api.post("/users/create-portal-session"),
  dismissAppUpdate: (userId: number, appUpdateId: number) =>
    api.post(`/users/dismiss-app-update/${userId}/${appUpdateId}`),
  dismissDraftPitchReminder: (userId: number) =>
    api.post(`/users/dismiss-draft-pitch-reminder/${userId}`),
};
